import { Head, router, useForm, usePage } from "@inertiajs/react"

import {
  EventForm,
  type EventFormData,
  type Neighborhood,
} from "@/components/events/event-form"
import AppLayout from "@/layouts/app-layout"
import { eventsPath } from "@/routes"

// Types now imported from the shared EventForm component

interface EventsNewProps {
  event: Record<string, unknown>
  neighborhoods: Neighborhood[]
  categories: { value: string; label: string; emoji?: string }[]
}

//

export default function EventsNew({
  neighborhoods,
  categories,
}: EventsNewProps) {
  const page = usePage()
  const search = page.url.includes("?") ? page.url.split("?")[1] : ""
  const params = new URLSearchParams(search)
  const from = params.get("from")

  const { data, setData, post, processing, errors } = useForm<{
    event: EventFormData
  }>({
    event: {
      title: "",
      description: "",
      category: "",
      start_date: "",
      end_date: "",
      venue_name: "",
      address: "",
      latitude: "",
      longitude: "",
      neighborhood_id: "",
      city_id: (neighborhoods?.[0]?.city?.id ?? "") as string | number,
      price: "",
      is_free: true,
      capacity: "100",
      visibility: "city",
      featured: false,
      image: null,
      image_url: "",
      remove_image: false,
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    post(eventsPath())
  }

  const handleCancel = () => {
    if (from) {
      router.visit(from)
    } else {
      router.visit(eventsPath())
    }
  }

  const err = errors as unknown as Record<string, string>

  return (
    <AppLayout>
      <Head title="Crear Evento" />

      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <EventForm
          title="Crear evento"
          data={data.event}
          errors={err}
          neighborhoods={neighborhoods}
          categories={categories}
          processing={processing}
          onChange={(partial) =>
            setData("event", { ...data.event, ...partial })
          }
          onSubmit={submit}
          onCancel={handleCancel}
          submitLabel="Guardar"
        />
      </div>
    </AppLayout>
  )
}
